<div class="w-full mx-auto p-5 space-y-5">

  <!-- Header -->
  <div class="flex flex-wrap justify-between items-end gap-4">
    <div>
      <div class="flex items-center gap-2 text-xs font-medium text-slate-500 uppercase tracking-wider">
        <span>Tesorería</span>
        <span class="text-slate-300">/</span>
        <span class="text-slate-700">Notas Débito</span>
      </div>
      <h1 class="text-2xl font-semibold text-slate-900 mt-1">Notas Débito</h1>
      <p class="text-sm text-slate-500 mt-1 tabular-nums">
        {{ totalRecords }} notas · Gestión de notas débito bancarias (entradas al banco)
      </p>
    </div>
    <a routerLink="/debit-notes/new" class="btn btn-primary">
      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2.2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4" />
      </svg>
      Nueva Nota Débito
    </a>
  </div>

  <!-- KPIs -->
  <div class="grid grid-cols-1 sm:grid-cols-3 gap-3">
    <div class="kpi-card kpi-emerald">
      <div class="kpi-label">
        <span class="kpi-icon">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4" />
          </svg>
        </span>
        Total Notas Débito
      </div>
      <div class="kpi-value">{{ totalDebits | currency }}</div>
      <div class="kpi-hint">Suma de cargos al banco</div>
    </div>

    <div class="kpi-card kpi-amber">
      <div class="kpi-label">
        <span class="kpi-icon">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
        </span>
        Último Mes
      </div>
      <div class="kpi-value">{{ lastMonthTotal | currency }}</div>
      <div class="kpi-hint">Movimientos de los últimos 30 días</div>
    </div>

    <div class="kpi-card kpi-violet">
      <div class="kpi-label">
        <span class="kpi-icon">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
        </span>
        Total Registros
      </div>
      <div class="kpi-value">{{ totalRecords }}</div>
      <div class="kpi-hint">Notas emitidas</div>
    </div>
  </div>

  <!-- Toolbar de filtros -->
  <div class="filters-toolbar">
    <div class="grid grid-cols-12 gap-3">

      <div class="col-span-12 md:col-span-4">
        <div class="relative">
          <svg class="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
          <input type="text" [(ngModel)]="searchTerm" (input)="onFilterChange()"
            placeholder="Buscar por documento, concepto o proyecto..."
            class="w-full pl-9 pr-3 h-[38px] border border-slate-200 rounded-lg text-sm bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent placeholder-slate-400">
        </div>
      </div>

      <div class="col-span-6 md:col-span-3">
        <p-dropdown [options]="banks" [(ngModel)]="selectedBank" (onChange)="onFilterChange()" styleClass="w-full"
          placeholder="Banco" optionLabel="bankName" optionValue="id" [showClear]="true" [filter]="true"
          appendTo="body" panelStyleClass="filter-dropdown-panel" [style]="{'width':'100%'}">
        </p-dropdown>
      </div>

      <div class="col-span-12 md:col-span-5 flex gap-2">
        <p-dropdown [options]="[
            {label: 'Solo Activas', value: 'active'},
            {label: 'Solo Anuladas', value: 'cancelled'},
            {label: 'Todas', value: 'all'}
          ]" [(ngModel)]="selectedCancellationFilter" (onChange)="onCancellationFilterChange()"
          styleClass="flex-1" placeholder="Estado" optionLabel="label" optionValue="value" appendTo="body"
          panelStyleClass="filter-dropdown-panel" [style]="{'width':'100%'}">
        </p-dropdown>

        <button (click)="toggleSortOrder()"
          class="flex-shrink-0 h-[38px] px-3 border border-slate-200 rounded-lg bg-white hover:bg-slate-50 flex items-center gap-1 text-sm text-slate-700 transition-colors"
          [title]="'Ordenar por ID ' + (sortOrder === 'desc' ? 'descendente' : 'ascendente')">
          <svg class="w-4 h-4 text-slate-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path *ngIf="sortOrder === 'desc'" stroke-linecap="round" stroke-linejoin="round" d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4" />
            <path *ngIf="sortOrder === 'asc'" stroke-linecap="round" stroke-linejoin="round" d="M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12" />
          </svg>
          <span class="tabular-nums">ID</span>
        </button>
      </div>

      <!-- Fila 2: fechas -->
      <div class="col-span-12 md:col-span-4">
        <p-dropdown [(ngModel)]="dateType" [options]="dateTypeOptions" (onChange)="onFilterChange()" styleClass="w-full"
          placeholder="Tipo de fecha" optionLabel="label" optionValue="value" appendTo="body"
          panelStyleClass="filter-dropdown-panel" [style]="{'width':'100%'}">
        </p-dropdown>
      </div>

      <div class="col-span-6 md:col-span-4">
        <p-calendar [(ngModel)]="startDate" (onSelect)="onFilterChange()" (onClearClick)="onFilterChange()"
          [showIcon]="true" placeholder="Desde" dateFormat="dd/mm/yy" [showClear]="true" styleClass="w-full"
          appendTo="body" panelStyleClass="filter-datepicker-panel">
        </p-calendar>
      </div>

      <div class="col-span-6 md:col-span-4">
        <p-calendar [(ngModel)]="endDate" (onSelect)="onFilterChange()" (onClearClick)="onFilterChange()"
          [showIcon]="true" placeholder="Hasta" dateFormat="dd/mm/yy" [showClear]="true" styleClass="w-full"
          appendTo="body" panelStyleClass="filter-datepicker-panel">
        </p-calendar>
      </div>
    </div>
  </div>

  <!-- Listado -->
  <div class="space-y-3">

    <!-- Empty state -->
    <div *ngIf="paginatedNotes.length === 0"
      class="bg-white border border-dashed border-slate-300 rounded-xl p-10 text-center">
      <div class="mx-auto w-12 h-12 rounded-full bg-slate-100 flex items-center justify-center mb-3">
        <svg class="w-6 h-6 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
      </div>
      <p class="text-sm font-medium text-slate-700">No hay notas débito</p>
      <a routerLink="/debit-notes/new" class="btn btn-secondary btn-sm mt-3 inline-flex">
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4" />
        </svg>
        Nueva Nota Débito
      </a>
    </div>

    <div *ngFor="let note of paginatedNotes" class="receipt-row"
      [class.is-cancelled]="note.isCancelled"
      [class.stripe-rose]="note.isCancelled"
      [class.stripe-emerald]="!note.isCancelled">

      <div class="status-stripe"></div>

      <div class="p-4 space-y-3">

        <div class="flex items-start justify-between gap-4">
          <div class="min-w-0 flex-1">
            <div class="flex items-center flex-wrap gap-2">
              <a [routerLink]="['/debit-notes/view', note.id]" target="_blank"
                class="inline-flex items-center gap-1.5 text-base font-semibold text-slate-900 hover:text-blue-700 transition-colors group">
                <span class="tabular-nums">{{ note.documentNumber }}</span>
                <svg class="w-3.5 h-3.5 text-slate-400 opacity-0 group-hover:opacity-100 transition-opacity"
                  fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
              </a>

              <span *ngIf="note.isCancelled" class="pill pill-rose">
                <i class="fas fa-ban"></i> Anulada
              </span>
              <span *ngIf="!note.isCancelled" class="pill pill-emerald">
                <i class="fas fa-check-circle"></i> Activa
              </span>
            </div>

            <p class="mt-1 text-xs text-slate-500 truncate" *ngIf="note.bank?.bankName">
              {{ note.bank.bankName }}
            </p>
          </div>

          <!-- Monto (positivo = entrada) -->
          <div class="flex-shrink-0 text-right">
            <p class="text-[11px] font-medium text-slate-400 uppercase tracking-wide">Monto</p>
            <p class="text-xl font-semibold text-emerald-700 tabular-nums leading-tight">
              +{{ note.amount | currency }}
            </p>
            <p class="text-[11px] text-slate-400 tabular-nums mt-0.5">
              {{ note.documentDate | date:'dd/MM/yy' }}
            </p>
          </div>
        </div>

        <!-- Grid metadatos -->
        <div class="grid grid-cols-2 md:grid-cols-3 gap-x-4 gap-y-3 pt-3 border-t border-slate-100">
          <div class="data-cell">
            <span class="data-label">Concepto</span>
            <span class="data-value truncate" [title]="note.concept">{{ note.concept }}</span>
          </div>
          <div class="data-cell" *ngIf="note.project">
            <span class="data-label">Proyecto</span>
            <span class="data-value truncate" [title]="note.project.name">{{ note.project.name }}</span>
          </div>
          <div class="data-cell">
            <span class="data-label">Creación</span>
            <span class="data-value tabular-nums">{{ note.createdAt | date:'dd/MM/yy' }}</span>
          </div>
        </div>

        <!-- Observaciones -->
        <div *ngIf="note.observations" class="text-xs text-slate-600 bg-slate-50 border border-slate-200 rounded-md px-3 py-2">
          <strong class="text-slate-700">Observaciones:</strong> {{ note.observations }}
        </div>

        <!-- Bloque anulación -->
        <div *ngIf="note.isCancelled"
          class="bg-rose-50/60 border border-rose-200 rounded-md p-3 text-sm flex items-start gap-2">
          <svg class="w-4 h-4 text-rose-600 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor"
            viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
          </svg>
          <div class="flex-1 min-w-0">
            <p class="text-rose-800"><strong class="font-semibold">Motivo:</strong> {{ note.cancellationReason }}</p>
            <div class="flex flex-wrap justify-between gap-x-4 text-xs text-rose-600 mt-1">
              <span><strong>Por:</strong> {{ note.cancelledBy }}</span>
              <span><strong>Fecha:</strong> {{ note.cancelledAt | date:'medium' }}</span>
            </div>
          </div>
        </div>

        <!-- Auditoría -->
        <app-audit-info [auditData]="{
            createdBy: note.createdBy,
            createdAt: note.createdAt,
            updatedBy: note.updatedBy,
            updatedAt: note.updatedAt
          }" layout="compact" size="sm">
        </app-audit-info>

        <!-- Acciones -->
        <div class="flex flex-wrap items-center justify-end gap-1 pt-2 border-t border-slate-100">
          <button (click)="downloadPdf(note)" [disabled]="isDownloadingPdf[note.id]" class="row-action" title="Descargar PDF">
            <svg *ngIf="!isDownloadingPdf[note.id]" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
            </svg>
            <svg *ngIf="isDownloadingPdf[note.id]" class="animate-spin" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
            </svg>
            <span>{{ isDownloadingPdf[note.id] ? 'Descargando…' : 'PDF' }}</span>
          </button>

          <a [routerLink]="['/debit-notes/view', note.id]" class="row-action row-action--primary" title="Ver detalle">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.8">
              <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
            </svg>
            <span>Detalle</span>
          </a>

          <ng-container *ngIf="!note.isCancelled">
            <span class="action-divider"></span>
            <button (click)="showCancelModal(note)" class="row-action row-action--danger" title="Anular nota débito">
              <i class="fas fa-ban"></i>
              <span>Anular</span>
            </button>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <!-- Paginador -->
  <div class="bg-white rounded-xl border border-slate-200">
    <p-paginator [rows]="pageSize" [totalRecords]="totalRecords" [rowsPerPageOptions]="[10, 20, 50, 100]"
      (onPageChange)="onPageChange($event)" [showCurrentPageReport]="true"
      currentPageReportTemplate="Mostrando {first}–{last} de {totalRecords}">
    </p-paginator>
  </div>

</div>

<!-- Modal Anulación -->
<div *ngIf="showConfirmationModal" class="fixed inset-0 z-50 overflow-y-auto" role="dialog" aria-modal="true">
  <div class="fixed inset-0 bg-slate-900/50 backdrop-blur-sm transition-opacity duration-300" (click)="onCancelCancellation()"></div>
  <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
    <div class="relative transform overflow-hidden rounded-xl bg-white text-left shadow-2xl transition-all duration-300 ease-out sm:my-8 sm:w-full sm:max-w-lg">
      <div class="bg-white px-5 pb-4 pt-5 sm:p-6 sm:pb-4">
        <div class="sm:flex sm:items-start">
          <div class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-rose-100 sm:mx-0 sm:h-10 sm:w-10">
            <i class="fas fa-ban text-rose-600 text-xl"></i>
          </div>
          <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left w-full">
            <h3 class="text-base font-semibold leading-6 text-slate-900">¿Anular nota débito?</h3>
            <p class="text-sm text-slate-500 leading-relaxed mt-2">Esta acción es irreversible. La nota será anulada y no se considerará en reportes.</p>
            <div *ngIf="selectedNoteForCancellation" class="mt-3 bg-slate-50 border border-slate-200 rounded-md p-3 text-sm text-slate-700 space-y-1">
              <p><span class="font-medium text-slate-500">Documento:</span> <span class="tabular-nums">{{ selectedNoteForCancellation.documentNumber }}</span></p>
              <p><span class="font-medium text-slate-500">Monto:</span> <span class="tabular-nums">{{ selectedNoteForCancellation.amount | currency }}</span></p>
              <p><span class="font-medium text-slate-500">Fecha:</span> <span class="tabular-nums">{{ selectedNoteForCancellation.documentDate | date:'mediumDate' }}</span></p>
            </div>
            <div class="mt-4">
              <label class="block text-sm font-medium text-slate-700 mb-2">Motivo de anulación <span class="text-rose-600">*</span></label>
              <textarea [(ngModel)]="cancellationReason" rows="3"
                class="w-full px-3 py-2 border border-slate-200 rounded-md focus:ring-2 focus:ring-rose-500 focus:border-rose-500 text-sm"
                placeholder="Especifique el motivo de la anulación..." maxlength="1000" required></textarea>
              <div class="mt-1 text-xs text-slate-500 text-right tabular-nums">{{ (cancellationReason.length || 0) }}/1000</div>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-slate-50 px-5 py-3 sm:flex sm:flex-row-reverse sm:px-6 border-t border-slate-200">
        <button type="button" class="btn btn-rose sm:ml-3" (click)="onConfirmCancellation()">
          <i class="fas fa-ban"></i> Anular nota
        </button>
        <button type="button" class="btn btn-secondary mt-3 sm:mt-0" (click)="onCancelCancellation()">Cancelar</button>
      </div>
    </div>
  </div>
</div>
